import React from "react"
import DateHelper from "../../DateHelper/DateHelper"

class ReservationSegmentCheckInCheckOutActionsDataType extends React.Component{
	constructor(props) {
		super(props);
	}

	render() {
		var check_in_date = DateHelper.parseDate(this.props.row.check_in_date);
		var check_out_date = DateHelper.parseDate(this.props.row.check_out_date);
		var currentDate = DateHelper.parseDate(this.props.row.currentDate) || DateHelper.today();
		var checked_in_at = DateHelper.parseDate(this.props.row.checked_in_at);
		var checked_out_at = DateHelper.parseDate(this.props.row.checked_out_at);

		check_in_date.setHours(0,0,0,0);
		check_out_date.setHours(0,0,0,0);
		currentDate.setHours(0,0,0,0);

		if (!checked_in_at) {
			return (
				<div><a href={'/admin/reservation-segments/check-in-check-out/' + this.props.row.id + '?action_name=check_in'} className='btn btn-dark btn-xs btn-block modal-iframe' data-fullscreen={true}>{I18n.t('check_in')}</a></div>
			);
		} else if (!checked_out_at && check_out_date.getTime() === currentDate.getTime()) {
			return (
				<div><a href={'/admin/reservation-segments/check-in-check-out/' + this.props.row.id + '?action_name=check_out'} className='btn btn-dark btn-xs btn-block modal-iframe' data-fullscreen={true}>{I18n.t('check_out')}</a></div>
			);
		} else {
			return (
				<div><a href={'/admin/reservation-segments/check-in-check-out/' + this.props.row.id + '?action_name=save'} className='btn btn-xs btn-dark btn-block modal-iframe' data-fullscreen={true}>{I18n.t('edit')}</a></div>
			)
		}
	}

};

export default ReservationSegmentCheckInCheckOutActionsDataType